(function () {
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastCartTrigger = null;
  var atcPending = false;
  var cartWasOpen = false;
  var menuWasOpen = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function setInert(el, makeInert) {
    if (!el) return;
    if (makeInert) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), function (el) {
      if (el.closest('[inert]')) return false;
      return el.getClientRects().length > 0;
    });
  }

  function syncMobileSubmenus() {
    var items = document.querySelectorAll('.jas-canvas-menu li.has-sub');
    for (var i = 0; i < items.length; i++) {
      var submenu = null;
      var children = items[i].children;
      for (var c = 0; c < children.length; c++) {
        if (children[c].tagName === 'UL') {
          submenu = children[c];
          break;
        }
      }
      if (!submenu) continue;
      setInert(submenu, !items[i].classList.contains('open'));
    }
  }

  function syncMobileDrawer() {
    var canvas = document.querySelector('.jas-canvas-menu');
    var menuOpen = document.body.classList.contains('menu-opened');
    setInert(canvas, !menuOpen);
    if (menuOpen) {
      syncMobileSubmenus();
    }
  }

  function closeCart() {
    document.body.classList.remove('cart-opened');
  }

  function closeMenu() {
    document.body.classList.remove('menu-opened');
  }

  function onCartOpenChange(isOpen) {
    var drawer = document.querySelector('.jas-mini-cart');
    if (!drawer) return;

    if (isOpen) {
      setInert(drawer, false);
      window.requestAnimationFrame(function () {
        var target =
          drawer.querySelector('.close-cart') ||
          drawer.querySelector('#CartDrawer-Heading') ||
          getFocusable(drawer)[0] ||
          drawer;
        if (target && typeof target.focus === 'function') {
          target.focus();
        }
      });
    } else {
      setInert(drawer, true);
      if (lastCartTrigger && typeof lastCartTrigger.focus === 'function') {
        lastCartTrigger.focus();
      }
      atcPending = false;
    }
  }

  function onMenuOpenChange() {
    syncMobileDrawer();
  }

  function trapCartFocus(event) {
    if (event.key !== 'Tab' || !document.body.classList.contains('cart-opened')) return;
    var drawer = document.querySelector('.jas-mini-cart');
    if (!drawer || drawer.hasAttribute('inert')) return;

    var list = getFocusable(drawer);
    if (!list.length) {
      event.preventDefault();
      if (typeof drawer.focus === 'function') drawer.focus();
      return;
    }

    var first = list[0];
    var last = list[list.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && (active === first || !drawer.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !drawer.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  /* ---------- Desktop mega menu keyboard support ---------- */

  function getTopLevelNavLinks() {
    return document.querySelectorAll(
      '#jas-main-menu > li > a, .jas-menu > li > a, ul.jas-menu > li > a'
    );
  }

  function getSubmenuForTopLink(link) {
    var li = link && link.parentElement;
    if (!li || li.tagName !== 'LI') return null;
    var children = li.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName === 'UL') return children[i];
    }
    return null;
  }

  function setNavExpanded(link, expanded) {
    if (!link) return;
    link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function initMegaMenuA11y() {
    var links = getTopLevelNavLinks();
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-a11y-nav') === '1') continue;
      var submenu = getSubmenuForTopLink(link);
      if (!submenu) continue;
      link.setAttribute('data-a11y-nav', '1');
      link.setAttribute('aria-haspopup', 'true');
      setNavExpanded(link, false);
    }
  }

  function syncNavExpandedFromFocus() {
    var links = getTopLevelNavLinks();
    var active = document.activeElement;
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (link.getAttribute('data-a11y-nav') !== '1') continue;
      var li = link.parentElement;
      var open = !!(li && active && li.contains(active));
      setNavExpanded(link, open);
    }
  }

  function handleMegaMenuEscape(event) {
    if (event.key !== 'Escape') return;
    if (document.body.classList.contains('cart-opened')) return;
    if (document.body.classList.contains('menu-opened')) return;

    var active = document.activeElement;
    if (!active) return;

    var li = active.closest && active.closest('.jas-menu > li, #jas-main-menu > li, ul.jas-menu > li');
    if (!li) return;

    var topLink = null;
    for (var i = 0; i < li.children.length; i++) {
      if (li.children[i].tagName === 'A') {
        topLink = li.children[i];
        break;
      }
    }
    if (!topLink || topLink.getAttribute('data-a11y-nav') !== '1') return;

    var submenu = getSubmenuForTopLink(topLink);
    if (!submenu) return;

    if (submenu.contains(active) && active !== topLink) {
      event.preventDefault();
      topLink.focus();
      setNavExpanded(topLink, true);
      return;
    }

    if (active === topLink) {
      event.preventDefault();
      topLink.blur();
      setNavExpanded(topLink, false);
    }
  }

  /* ---------- Variant swatch keyboard support ---------- */

  function getAllSwatches(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('gecko-swatch');
    });
  }

  function getSwatchOptions(list) {
    return getAllSwatches(list).filter(function (el) {
      return !el.classList.contains('jas_unavailable');
    });
  }

  function findSelectedSwatch(all) {
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i].classList.contains('is-selected')) return all[i];
    }
    for (i = 0; i < all.length; i++) {
      if (all[i].classList.contains('is-selected-none')) return all[i];
    }
    return null;
  }

  function syncSwatchGroup(list) {
    if (!list || list.getAttribute('role') !== 'radiogroup') return;
    var all = getAllSwatches(list);
    if (!all.length) return;

    /*
     * Every available swatch stays in the tab order (tabindex=0).
     * Roving tabindex only on the selected option caused Tab to skip
     * M/L/XL and land on the plus-size <a> links that sit in the same list.
     */
    var selected = findSelectedSwatch(all);

    for (var j = 0; j < all.length; j++) {
      var opt = all[j];
      var unavailable = opt.classList.contains('jas_unavailable');
      var checked = selected ? opt === selected : false;
      opt.setAttribute('role', 'radio');
      opt.setAttribute('aria-checked', checked ? 'true' : 'false');
      if (unavailable) {
        opt.setAttribute('aria-disabled', 'true');
        opt.setAttribute('tabindex', '-1');
      } else {
        opt.removeAttribute('aria-disabled');
        opt.setAttribute('tabindex', '0');
      }
    }
  }

  function enhanceSwatchList(list) {
    if (!list || list.getAttribute('data-a11y-swatch') === '1') {
      syncSwatchGroup(list);
      return;
    }

    list.setAttribute('data-a11y-swatch', '1');
    list.setAttribute('role', 'radiogroup');

    var title = list.parentElement && list.parentElement.querySelector('.swatch__title');
    if (title) {
      var labelText = (title.textContent || '').replace(/\s+/g, ' ').trim();
      if (labelText) {
        list.setAttribute('aria-label', labelText.split(':')[0].trim() || labelText);
      }
    }

    var options = Array.prototype.filter.call(list.children, function (el) {
      return el.nodeType === 1 && el.classList.contains('gecko-swatch');
    });
    for (var i = 0; i < options.length; i++) {
      options[i].setAttribute('role', 'radio');
    }

    syncSwatchGroup(list);

    list.addEventListener('keydown', function (event) {
      var target = event.target.closest && event.target.closest('.gecko-swatch');
      if (!target || !list.contains(target)) return;

      var keys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End', ' ', 'Enter'];
      if (keys.indexOf(event.key) === -1) return;

      var opts = getSwatchOptions(list);
      if (!opts.length) return;

      var index = opts.indexOf(target);
      if (index < 0) return;

      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        target.click();
        syncSwatchGroup(list);
        return;
      }

      var next = index;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (index + 1) % opts.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (index - 1 + opts.length) % opts.length;
      } else if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = opts.length - 1;
      }

      if (next === index) return;
      event.preventDefault();
      opts[next].click();
      syncSwatchGroup(list);
      if (typeof opts[next].focus === 'function') opts[next].focus();
    });

    list.addEventListener('click', function () {
      window.setTimeout(function () {
        syncSwatchGroup(list);
      }, 0);
    });
  }

  function enhanceAllSwatches(root) {
    var scope = root || document;
    var lists = scope.querySelectorAll
      ? scope.querySelectorAll('ul.swatches-select')
      : [];
    for (var i = 0; i < lists.length; i++) {
      enhanceSwatchList(lists[i]);
    }
  }

  ready(function () {
    var canvas = document.querySelector('.jas-canvas-menu');
    var drawer = document.querySelector('.jas-mini-cart');

    if (drawer) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      if (!drawer.getAttribute('aria-labelledby') && !drawer.getAttribute('aria-label')) {
        drawer.setAttribute('aria-labelledby', 'CartDrawer-Title');
      }
      if (!drawer.hasAttribute('tabindex')) {
        drawer.setAttribute('tabindex', '-1');
      }
    }

    cartWasOpen = document.body.classList.contains('cart-opened');
    menuWasOpen = document.body.classList.contains('menu-opened');
    syncMobileDrawer();
    setInert(drawer, !cartWasOpen);

    initMegaMenuA11y();
    enhanceAllSwatches(document);

    document.addEventListener(
      'click',
      function (event) {
        var atc = event.target.closest('.ajax_form_cart, .ajax_add_to_cart, .shopify_add_to_cart');
        if (atc) {
          lastCartTrigger = atc;
          atcPending = true;
          return;
        }
        var cartLink = event.target.closest('.jas-sidebar-cart > a');
        if (cartLink && !atcPending) {
          lastCartTrigger = cartLink;
        }
      },
      true
    );

    document.addEventListener('focusin', function () {
      syncNavExpandedFromFocus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (document.body.classList.contains('cart-opened')) {
          event.preventDefault();
          closeCart();
          return;
        }
        if (document.body.classList.contains('menu-opened')) {
          event.preventDefault();
          closeMenu();
          return;
        }
        handleMegaMenuEscape(event);
        return;
      }
      trapCartFocus(event);
    });

    new MutationObserver(function () {
      var cartOpen = document.body.classList.contains('cart-opened');
      var menuOpen = document.body.classList.contains('menu-opened');
      if (cartOpen !== cartWasOpen) {
        cartWasOpen = cartOpen;
        onCartOpenChange(cartOpen);
      }
      if (menuOpen !== menuWasOpen) {
        menuWasOpen = menuOpen;
        onMenuOpenChange();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    if (canvas) {
      new MutationObserver(function () {
        if (document.body.classList.contains('menu-opened')) {
          syncMobileSubmenus();
        }
      }).observe(canvas, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }

    /* Quick view and AJAX content inject swatches after load */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('ul.swatches-select')) {
            enhanceSwatchList(node);
          } else if (node.querySelectorAll) {
            enhanceAllSwatches(node);
          }
          if (node.matches && (node.matches('.jas-menu') || node.matches('#jas-main-menu') || node.querySelector('.jas-menu'))) {
            initMegaMenuA11y();
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  });
})();
